import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "semantic-ui-react";

class TermsModal extends Component {
  render() {
    const { open, onClose } = this.props;
    return (
      <Modal open={open}>
        <Modal.Header>Account Terms and Conditions</Modal.Header>
        <Modal.Content>
          <p>
            <strong>Agreement of Terms</strong>
          </p>
          <table border="0" cellSpacing="0" cellPadding="0" width="100%">
            <tbody>
              <tr>
                <td>
                  <p>
                    Welcome to Indiana Farmers Mutual Insurance Group’s ("IFMIG") online
                    Web services. Before registering, please take a few minutes
                    to review the Terms and Conditions associated with the use
                    of this site and this free service. When you have completed
                    your review, indicate your agreement with these terms by
                    clicking the Agree button. You will be automatically taken
                    to the online registration page. Once you agree to these
                    terms, you will be able to make your online payments. If you
                    choose to not accept these terms and conditions, as stated,
                    please select the Disagree button and you will be returned
                    to the Company’s home page. Thank you for your business!
                    <br />
                    <br />
                    This document forms the basis of the agreement between you
                    and IFMIG. It is important that you understand both
                    the benefits and limitations.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p align="center">
                    <strong>
                      <u>Terms and Conditions</u>
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>1. Agreement</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    By enrolling or registering for our service, you are
                    indicating that you would like to make online payments for
                    policy premiums.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>2. Services</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    IFMIG provides a service
                    that enables its policyholders to make payments on premium
                    invoices using various methods including accepted credit
                    cards and echeck.
                    <br />
                    <br />
                  </p>
                  <ul type="disc">
                    <li>
                      <strong>Service Limitations</strong>
                      <br />
                      IFMIG will take
                      commercially reasonable efforts to make your experience
                      with our service a productive and pleasant one. However,
                      technical or other difficulties cannot always be foreseen.
                      These difficulties may result in the loss of data,
                      personalized settings, or other service interruptions.
                      <br />
                      <br />
                    </li>
                    <li>
                      <strong>Service Changes and Discontinuance</strong>
                      <br />
                      IFMIG reserves the
                      right to change or discontinue, temporarily or
                      permanently, this on-line service at any time without
                      notice. IFMIG will not be liable to you or any third party for
                      any damages associated with any notification or
                      discontinuance of the service.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>3. Conditions for Use</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    By registering for our service, you are indicating that you
                    would like to make credit card and echeck payments for
                    policy premiums.
                    <br />
                    <br />
                  </p>
                  <ul type="disc">
                    <li>
                      <strong>Provide Accurate Information</strong>
                    </li>
                    <ul type="circle">
                      <li>
                        You agree to provide true, accurate, current, and
                        complete information as required.
                      </li>
                      <li>You agree not to misrepresent your identity.</li>
                      <li>
                        You agree to keep your account information up to date
                        and accurate.
                      </li>
                    </ul>
                  </ul>
                  <ul>
                    <li>
                      <strong>Guard Your Password</strong>
                      <br />
                      You will be asked for a user name and password when
                      registering. You are responsible for maintaining the
                      confidentiality of your user name and password. You are
                      fully responsible for all activities that occur using your
                      user name and password, or policy number. Any unauthorized
                      use of your password, policy number, or any breach of
                      security must be immediately reported to IFMIG. Commercially responsible steps
                      have been taken to protect the privacy of any individual
                      user of this site and any personal information collected
                      in connection to one’s registration to use the site.
                      IFMIG will not be
                      liable for any loss that you might incur as a result of
                      someone else using your user name or password, either with
                      or without knowledge. You may not use anyone else’s
                      password at any time.
                    </li>
                    <li>
                      <strong>Remember Your Password</strong>
                      <br />
                      Please make sure that you remember your password,
                      particularly when you are assigning your own password
                      during the account set up process. For security reasons,
                      the Company’s policy system does not automatically reset
                      passwords. IFMIG
                      assumes no responsibility for the inability to process
                      echeck or credit card payments on the web (i.e., due to
                      not having an active password).
                    </li>
                    <li>
                      <strong>Payments</strong>
                      <br />
                      You agree not to use this service for illegal purposes or
                      for the transmission of material that is unlawful,
                      harassing, libelous (untrue and damaging to others),
                      invasive of other’s privacy, abusive, threatening, or
                      obscene, or that infringes on the rights of others.
                      <br />
                      <br />
                    </li>
                  </ul>
                  <ul type="disc">
                    <li>
                      <strong>Unauthorized Access and Use</strong>
                      <br />
                      These electronic services are provided for the use of
                      IFMIG policyholders for
                      Indiana Farmer’s legitimate business purposes only. The
                      actual or attempted unauthorized access, use, or
                      modification of this system is strictly prohibited by
                      IFMIG. Unauthorized
                      users are subject to criminal and civil penalties under
                      state, federal or other applicable domestic and foreign
                      laws. The use of this system may be monitored and recorded
                      for administrative and security purposes. Anyone accessing
                      the system expressly consents to such monitoring and is
                      advised that if such monitoring reveals possible evidence
                      of criminal activity, IFMIG may provide evidence of such activity to law
                      enforcement officials.
                      <br />
                      <br />
                    </li>
                    <li>
                      <strong>Proprietary Rights</strong>
                      <br />
                      You acknowledge and agree that IFMIG owns 
                      the rights to this web site and the
                      content displayed on the site. You are only permitted to
                      use this content as expressly authorized. IFMIG retains any 
                      and all of its
                      copyrights and other exclusive rights to the entire site.
                      Except as otherwise allowed by law, no right is given to
                      otherwise use, copy, print, download, transfer, display,
                      perform, reproduce, license, post, forward, transmit,
                      distribute, or publish any information from this site, in
                      whole or in part, without the advance written permission
                      of IFMIG.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>
                      4. Rights You Grant to Indiana Farmers Mutual Insurance
                      Group
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <ul type="disc">
                    <li>
                      <strong>Advertising</strong>
                      <br />
                      You agree that IFMIG
                      may display advertisements and promotions of all kinds in
                      and with our service.
                      <br />
                      <br />
                    </li>
                    <li>
                      <strong>Access</strong>
                      <br />
                      In order to ensure that IFMIG is able to 
                      provide high quality services, you
                      agree that IFMIG
                      employees may have access to your account and records as
                      reasonably needed to investigate complaints and/or
                      otherwise provide service and support, as needed.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>5. Disclaimer of Warranties</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>You expressly understand and agree that:</p>
                  <ul type="disc">
                    <li>
                      Your use of this service is at your own risk and this site
                      and all content, material, information software, products
                      and services provided on this site are provided on an “as
                      is” and “as available” basis. All warranties of any kind
                      whether express or implied, including but not limited to,
                      the implied warranties of merchantability, fitness for a
                      particular purpose and non-infringement are hereby
                      expressly disclaimed by IFMIG. IFMIG makes no
                      warranty that:
                      <br />
                      <br />
                      <br />
                    </li>
                    <ul type="circle">
                      <li>The site will meet your requirements.</li>
                      <li>
                        The site will be available on an uninterrupted, timely,
                        secure, or error-free basis.
                      </li>
                      <li>
                        The quality of the products, services, information, or
                        other material purchased or obtained by you through this
                        site will meet your expectations.
                      </li>
                      <li>Any errors in technology will be corrected.</li>
                    </ul>
                    <li>
                      Any content, materials, information or software
                      downloaded, or otherwise obtained through the use of the
                      site is done at your own discretion and risk. IFMIG shall have no
                      responsibility for any damage to your computer system or
                      loss of data that results from the download of any
                      content, materials, information, or software.
                      <br />
                      <br />
                      IFMIG reserves the
                      right to make changes or updates to the site at any time
                      without notice.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>6. Limitation of Liability</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    By using this site, you, as user, agree to expressly limit
                    IFMIG from any and all
                    liability for any direct, indirect, incidental, special or
                    consequential damages, or damages from loss of profits,
                    revenue, data or use, incurred by you as user or any third
                    party, whether, in an action in contract or tort, arising
                    from access to, or use of, this site.
                    <br />
                    <br />
                    Some of the limitations may not apply to you if you live in
                    a jurisdiction that forbids or does not allow them.
                    <br />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>7. Indemnification</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    You agree to defend, indemnify and hold harmless IFMIG, 
                    its affiliates (agencies),
                    and service providers from any and all claims, liability,
                    damages, losses or expenses (including, but not limited to,
                    reasonable attorney fees and costs) caused by or arising
                    from your use of this service, your violation of the Terms
                    and Conditions, or your infringement, or infringement by any
                    other user of your account, of any intellectual property or
                    other right of anyone, or any other loss arising out of or
                    in any way connected with access or use of this site.
                    <br />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>8. Applicable Law</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    All matters relating to access to and use of this site shall
                    be governed by Indiana law. Any legal action or proceeding
                    relating to your access to, or use of, shall be governed in
                    accordance with the laws of the State of Indiana. You and
                    IFMIG agree to submit to
                    the jurisdiction of, and agree that the venue is proper in
                    the State of Indiana in any such legal action or proceeding.
                    <br />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>9. Miscellaneous</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <ul type="disc">
                    <li>
                      <strong>Amendments</strong>
                      <br />
                      The agreement cannot be changed or any of IFMIG’s 
                      rights waived unless IFMIG expressly agrees in
                      writing or you continue using this service following the
                      receipt of notice of any changes proposed by IFMIG.
                      <br />
                      <br />
                    </li>
                    <li>
                      <strong>Assignments</strong>
                      <br />
                      This agreement is personal to you and you may not assign
                      it to anyone.
                      <br />
                      <br />
                    </li>
                    <li>
                      <strong>Severability</strong>
                      <br />
                      If any provision of these Terms and Conditions is held to
                      be unforeseeable, then such provision shall be construed,
                      as nearly as possible, to reflect the intentions of the
                      parties with the other provisions remaining in full force
                      and effect.
                      <br />
                      <br />
                    </li>
                    <li>
                      <strong>Entire Agreement</strong>
                      <br />
                      All terms and conditions set forth herein constitute the
                      entire understanding between you and IFMIG.
                      <br />
                      <br />
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={onClose}>Close</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

TermsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TermsModal;
